import { StandardEvents } from '@shopify/events';

/**
 * Keeps the branding explainer in sync with the selected variant.
 *
 * The variant picker fetches the re-rendered section rather than reloading the page, so
 * each block is responsible for pulling its own updated markup out of `detail.html`.
 */
class BrandingNote extends HTMLElement {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section = null;
  }

  /** @param {any} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then((/** @type {any} */ { detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const updated = html.querySelector(`branding-note[data-block-id="${this.dataset.blockId}"]`);
        if (!updated) return;

        this.innerHTML = updated.innerHTML;
        this.toggleAttribute('hidden', updated.hasAttribute('hidden'));
      })
      .catch((/** @type {any} */ error) => {
        if (error?.name !== 'AbortError') console.warn('[branding-note] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('branding-note')) {
  customElements.define('branding-note', BrandingNote);
}
